export interface Derivatives {
    series: string;
    season?: string;
}

export interface Competition {
    id: number;
    name: string;
    derivatives: Derivatives;
}

export interface Format {
    name: string;
    value: number;
    isMapTieable: boolean;
}

export interface Link {
    link: string;
    rel: string;
}

export interface Participant {
    id: number;
    name: string;
    score: number;
    scoreWithoutHandicap: number;
    handicap: number;
}

export interface Sport {
    alias: string;
    name: string;
}

export interface Verification {
    needsVerification: boolean;
    verifiedBy: number;
    verifiedTimestamp: number;
    verified: boolean;
}

export interface Metadata {
    id: number;
    fixtureId: number;
    attribute: string;
    value: string;
}

export interface Player {
    adr: number;
    dpr: number;
    kpr: number;
    kast: number;
    name: string;
    kills: number;
    deaths: number;
    assists: number;
    playerId: number;
    suicides: number;
    headshots: number;
    entryKills: number;
    flash_assists: number;
    clutches: {
        type: string,
        mapNumber?: number, // Not part of the domain model, added for tracking
        round: number
    }[]
}

export interface ClutchBase {
    id: number;
    mapNumber: number;
    roundNumber: number;
}

export interface OneVersusX extends ClutchBase { // 1v1, 1v2, 1v3, 1v4, 1v5
}


export interface MultiKill extends ClutchBase {
}

export interface EntryKill {
    mapNumber: number;
    roundNumber: number;
}

export interface PlayerExpanded extends Player {
    oneVersusXs?: OneVersusX[];
    multiKills?: MultiKill[];
    entryKillClutches?: EntryKill[];
}

export interface TeamStat {
    kills: number;
    deaths: number;
    teamId: number;
    assists: number;
    players: PlayerExpanded[];
    suicides: number;
    headshots: number;
    startSide: string;
    entryKills: number;
    flash_assists: number;
}

export interface RoundScore {
    id: number;
    roundsWon: number;
}

export interface MapDetails {
    tie: boolean;
    status: string;
    mapName: string;
    winnerId: string;
    mapNumber: number;
    teamStats: TeamStat[];
    roundScores: RoundScore[];
    mapDataStatus?: string; // verified, live
}

export interface FixtureDetailed {
    competition: Competition;
    endTime: number;
    format: Format;
    id: number;
    links: Link[];
    participants: Participant[];
    scheduledStartTime: number;
    sport: Sport;
    startTime: number;
    status: string;
    tie: boolean;
    verification: Verification;
    winnerId: number;
    metadata: Metadata[];
    hidden: boolean;
    maps: MapDetails[];
}

export const EmptyFixture = (): FixtureDetailed => {
    return {
        competition: undefined as unknown,
        endTime: undefined as unknown,
        format: undefined as unknown,
        id: undefined as unknown,
        links: undefined as unknown,
        participants: undefined as unknown,
        scheduledStartTime: undefined as unknown,
        sport: undefined as unknown,
        startTime: undefined as unknown,
        status: undefined as unknown,
        tie: undefined as unknown,
        verification: undefined as unknown,
        winnerId: undefined as unknown,
        metadata: undefined as unknown,
        hidden: undefined as unknown,
        maps: []
    } as FixtureDetailed
}

export const verified = (fixture: FixtureDetailed) : boolean => {
    const maps : MapDetails[] = fixture.maps;
    return maps && !!maps.length && maps.every(map => map.mapDataStatus === "verified"); 
}